import { delCookie } from './cookie';
import { tokenName } from '@/config/project';

let generation = 0;

export function sessionSnapshot() {
  let token = '';
  try { token = JSON.parse(localStorage.getItem('token')) || ''; } catch (error) { token = ''; }
  return { token: typeof token === 'string' ? token : '', generation };
}

export function isCurrentSession(snapshot) {
  const current = sessionSnapshot();
  return !!snapshot && snapshot.generation === current.generation && snapshot.token === current.token;
}

export function advanceSession() { generation++; }

export function clearLoginState() {
  advanceSession();
  [tokenName, 'token', 'userMessObj'].forEach(delCookie);
  ['token', 'userInfo', 'apiFullRoute', 'needResetPwd'].forEach(key => localStorage.removeItem(key));
}

export function logoutLocally(sendLogout, onLocalExit, onUnconfirmed) {
  let pending;
  try { pending = Promise.resolve(sendLogout()); } catch (error) { pending = Promise.reject(error); }
  clearLoginState();
  const exited = sessionSnapshot();
  onLocalExit();
  return pending.then(res => !!(res && res.code === 200), () => false).then(confirmed => {
    if (!confirmed && isCurrentSession(exited)) onUnconfirmed();
    return confirmed;
  });
}
